"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PonziContractDialogEdit = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_image_firebase_1 = require("@dzambalaorg/mui-inputs-image-firebase");
const mui_inputs_draft_1 = require("@dzambalaorg/mui-inputs-draft");
const types_1 = require("@framework/types");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const popovers_1 = require("../../../../../../popovers");
const types_2 = require("../../../../../../types");
const validation_1 = require("./validation");
const PonziContractDialogEdit = (props) => {
    const { selectedItem, open, mode, service, ...rest } = props;
    if (!open || !selectedItem) {
        return null;
    }
    const { id, title, imageUrl, contractStatus, description, address, contractFeatures, merchantId } = selectedItem;
    const fixedValues = {
        id,
        title,
        address,
        imageUrl,
        description,
        contractStatus,
        contractFeatures,
        merchantId: (service === types_2.ServiceType.OFFICE && merchantId) || undefined,
    };
    return ((0, jsx_runtime_1.jsxs)(mui_dialog_form_1.FormDialog, { open: open, initialValues: fixedValues, validationSchema: validation_1.validationSchema, message: `dialogs.${mode}`, testId: "PonziContractEditForm", action: id ? (0, jsx_runtime_1.jsx)(popovers_1.BlockchainInfoPopover, { address: address, contractFeatures: contractFeatures }) : null, filter: ({ title, description, imageUrl, contractStatus, merchantId }) => ({
            title,
            description,
            imageUrl,
            contractStatus,
            merchantId: (service === types_2.ServiceType.OFFICE && merchantId) || undefined,
        }), ...rest, children: [service === types_2.ServiceType.OFFICE && (0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: "merchantId", controller: "merchants", disableClear: true }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "title" }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "contractStatus", options: types_1.ContractStatus, disabledOptions: [types_1.ContractStatus.NEW] }), (0, jsx_runtime_1.jsx)(mui_inputs_image_firebase_1.AvatarInput, { name: "imageUrl" }), (0, jsx_runtime_1.jsx)(mui_inputs_draft_1.RichTextEditor, { name: "description" })] }));
};
exports.PonziContractDialogEdit = PonziContractDialogEdit;
//# sourceMappingURL=index.js.map